/**
 *  @author:        Cloud for Good
 *  @description:   Applies custom Advancement logic to the SFRA js/product/productDetail.js client-side logic.
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2022-09-30    Cloud for Good       N/A                Initial creation
 *  2025-02-13    Jassin Yacks (CFG)   CFG-751            Enhanced the Merchandise Page to include product options and updated the Add to Cart functionality to properly populate the confirmation window.
 *  2025-03-10    Jassin Yacks (CFG)   CFG-991            Allows customers to select and direct gift funds to a specific product via a picklist on the PDP.
*/

'use strict';

var base = require('base/product/base');
var detailBase = require('base/product/detail');

/**
 *  Normalize carousel height to the tallest of carousel items to prevent jumping on page
 */

function normalizeCarouselHeight() {

    var items   = $('.pdp-testimonial-carousel .carousel-item'),              // grab all the slides
    heights = [],                                   // array to store heights
    tallest;                                        // tallest slide

    if (items.length) {
        items.each(function() {
            heights.push($(this).height());
        });

        // get the tallest height
        tallest = Math.max.apply(null, heights);
        // add some padding
        tallest += 15;

        // set each item to the tallest height
        items.each(function() {
            $(this).css('height', tallest + 'px');
        });

        // set carousel inner row to tallest height
        $('.pdp-testimonial-carousel .carousel-inner').css('height', tallest + 'px');
    };
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Updates the base updateAttributesAndDetails function to display the color swatch value next to the color label (e.g., Color: Red).
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
detailBase.updateAttributesAndDetails = function() {
    $('body').on('product:statusUpdate', function (e, data) {
        var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

        //Updates the displayed selected color next to the "Color" label on the product page.
        const colorAttribute = data.variationAttributes.find(attr => attr.attributeId === "color");
        const selectedColorAttr = colorAttribute.values.find(value => value.selected);

        const $colorDisplay = $productContainer.find('.attributes .colorDisplayValue').empty();
        if (selectedColorAttr.displayValue) {
            $colorDisplay.text(selectedColorAttr.displayValue);
        }

        $productContainer.find('.description-and-detail .product-attributes')
            .empty()
            .html(data.attributesHtml);

        if (data.shortDescription) {
            $productContainer.find('.description-and-detail .description')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .description .content')
                .empty()
                .html(data.shortDescription);
        } else {
            $productContainer.find('.description-and-detail .description')
                .addClass('hidden-xl-down');
        }

        if (data.longDescription) {
            $productContainer.find('.description-and-detail .details')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .details .content')
                .empty()
                .html(data.longDescription);
        } else {
            $productContainer.find('.description-and-detail .details')
                .addClass('hidden-xl-down');
        }
    });
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * determines the product to update the price and the frequency
 * @param {element} - element targeted
 * @returns {json} amount (number), frequency (text), subscriptionMode (text), isValidAmount (boolean), minAmount (integer), activeTabId (string)
 */
function getProductOptions() {
    var options,
        productColor, 
        productSize, 
        productQty,
        productPrice,
        giftAmount,
        productTotal,
        selectFund;

    // Grab all the attributes from the selected product
    productColor = $('.color-attribute span.swatch-value.selected.selectable').parent().text().trim();

    productSize = $('.slds-select.select-size').find(":selected").text().trim();
    productQty = $('.quantity-select').val();
    selectFund = $('.fund-select').val();
    productPrice = $('.sales .value').text().trim();
    giftAmount = parseFloat($('.prices').attr('data-donationamt')).toFixed(2);
    giftAmount = giftAmount * productQty;

    // Calculate the total price
    var digitMatch = productPrice.match(/^(\D+)([\d,.]+)$/);
    
    if (!digitMatch) return null;

    var currencySymbol = digitMatch[1];
    var numericPrice = parseFloat(digitMatch[2].replace(/,/g, ''));
    var totalAmount = numericPrice * productQty;

    // Format back as currency
    productTotal = currencySymbol + totalAmount.toFixed(2);

    options = {
        color: productColor,
        size: productSize,
        qty: productQty,
        price: productPrice,
        donation: giftAmount,
        seletedFund: selectFund,
        total: productTotal
    }

    return options;
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response, color, size, qty, donation, total) {

    if(response){
        $('.minicart').trigger('count:update', response);
        var messageType = response.error ? 'alert-danger' : 'alert-success';

        // show add to cart toast
        if (response.newBonusDiscountLineItem
            && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
            chooseBonusProducts(response.newBonusDiscountLineItem);
        } else if(response.error) {
            if ($('.add-to-cart-messages').length === 0) {
                $('body').append(
                    `<div class="add-to-cart-messages alert ${messageType} alert-dismissible fade show" role="alert" tabindex="-1">
                        <h4 class="alert-heading">${response.title}</h4>
                        <p class="alert-message">${response.message}</p>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>`
                );
                $(".add-to-cart-messages").focus();
            }

        } else{
            //update the success modal with information from the product selected
            var $productAddedSuccessfullyModal = $('#productAddedSuccessfullyModal');

            $productAddedSuccessfullyModal.find('.gift-added-component-image')
                .attr({
                    'src': response.productImage,
                    'alt': response.imageAlt,
                    'title': response.imageTitle
                });

            $productAddedSuccessfullyModal.find('.slds-text-title_bold section').replaceWith(`<section>${response.productName}</section>`);
            if(color.trim().length > 0) {
                $productAddedSuccessfullyModal.find('.product-color span').text(color);
            }else{
                $productAddedSuccessfullyModal.find('.product-color').parent().hide()
            }
            if(size.trim().length > 0) {
                $productAddedSuccessfullyModal.find('.product-size span').text(size);
            }else{
                $productAddedSuccessfullyModal.find('.product-size').parent().hide()
            }
            $productAddedSuccessfullyModal.find('.product-qty span').text(qty);
            $productAddedSuccessfullyModal.find('.product-gift-amount span').text(`$${donation}`);
            $productAddedSuccessfullyModal.find('.product-total span').text(total);

            $('.informative-alert-icon').show(); //display product informative alert message and icon
            $('.gift-alert-icon').children().hide(); //hide product alert validation message and icon

            $productAddedSuccessfullyModal.modal('show'); //Display product added successfully modal
        }

        //set/update a cookie for the cart quantity
        //to ensure cookies get set based on the site, only set the domain for non-prod & Development sites
        if((document.location.host).includes('.northeastern.edu')){
            document.cookie = 'cartcount=' + response.quantityTotal + '; path=/ ;samesite=lax; domain=northeastern.edu';
        }else{
            document.cookie = 'cartcount=' + response.quantityTotal + '; path=/ ;samesite=lax';
        }
    }
}

module.exports = {
    //these functions come from the SFRA base file
    availability: base.availability,
    updateAttribute: detailBase.updateAttribute,
    showSpinner: detailBase.showSpinner,
    updateAddToCart: detailBase.updateAddToCart,
    updateAvailability: detailBase.updateAvailability,
    sizeChart: detailBase.sizeChart,
    copyProductLink: detailBase.copyProductLink,
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    //On mobile, when a user selects the give now button on the pdp page the button
    //will scroll to the gift options title
    mobileDonateButtonScrollTo: function () {
        $('body').on('click', '.gift-options-mobile .donate-btn', function (e) {
            document.querySelector('#giftOptionsTitle').scrollIntoView({ behavior: 'smooth' });
        });
    },

    // when page is loaded, normalize testimonial carousel height to prevent jumping heights
    normalizeTestimonialCarousel : function() {
        $(window).on('load', function() {
            normalizeCarouselHeight();
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart', function (e) {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var productColor;
            var productSize;
            var productQty;
            var giftAmount;
            var seletedFund;
            var productTotal;

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('button.add-to-cart')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = base.getPidValue($(this));

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();

            // Validate the physical product fund selection 
            if ($('.fund-select option').length === 0 || $('.fund-select').val() === null || $('.fund-select').val() === '') {
                $('.fund-select').attr('aria-invalid', 'true').closest('.slds-form-element').addClass("slds-has-error");
                $.spinner().stop();
                return;
            }else{
                $('.fund-select').removeAttr('aria-invalid').closest('.slds-form-element').removeClass("slds-has-error");
            }

            // Retrieve the gift amount, chosen fund, and other variation attributes from the product detail page (PDP).
            var options = getProductOptions($(this));
            productColor = options.color;
            productSize = options.size;
            productQty = options.qty;
            giftAmount = options.donation;
            seletedFund = options.seletedFund;
            productTotal = options.total;

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                physcialProductFund: seletedFund,
                childProducts: getChildProducts(),
                quantity: base.getQuantitySelected($(this))
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data, productColor,  productSize, productQty, giftAmount, productTotal);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                        base.miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

};